import React, { Component } from "react"
import OutsideClickTrigger from "../common/OutsideClickTrigger"
import config from "react-global-configuration"

class ParkingShowMapModal extends Component {
  state = { mobileActive: false }

  componentDidMount() {
    // new PanningMap({ el: this.refs.panningMapContainer })
    // new ParkingLotPicker({ el: this.refs.parkingLotPickerContainer })
  }

  activateMobileMap = (e) => {
    this.setState({ mobileActive: true })
  }

  getClass = (type) => {
    if (type.startsWith("We Park You Fly")) return "weparkyoufly"
    switch (type) {
      case "Budget":
        return "budget"
      case "Direct":
        return "direct"
      case "Standard":
        return "standard"
      case "Standard+":
        return "standard-plus"
      default:
        return ""
    }
  }
  render() {
    const textKeys = config.get("textKeys.parkingList.mapModal") || {}
    const key = this.props.item.name === "We park you fly" ? this.props.item.name : this.props.item.carPark.name
    const longitude = this.props.content.carParks[key].geoLocation.x
    const latitude = this.props.content.carParks[key].geoLocation.y

    return (
      <div className={!this.state.mobileActive ? "overlay overlay--modal overlay--fixed is-active" : ""}>
        <div className={!this.state.mobileActive ? "modal modal--iframe-modal" : ""}>
          <OutsideClickTrigger onOutsideClick={this.props.handleCloseMapModal}>
            <React.Fragment>
              <button className="button button--icon modal-close close-map" onClick={this.props.handleCloseMapModal}>
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content modal__content--no-padding">
                <div className="modal__content__inner">
                  <div className="modal__middle" style={{ padding: "0px", margin: "0px" }}>
                    <div className="modal__middle__inner">
                      <iframe
                        title="Google Maps Modal"
                        id="gmap_canvas"
                        src={`https://maps.google.com/maps?q=${latitude},${longitude}&output=embed`}
                        width="100%"
                        height="500"
                        frameBorder={0}
                        scrolling="no"
                        marginHeight={0}
                        marginWidth={0}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          </OutsideClickTrigger>
        </div>
      </div>
    )
  }
}
export default ParkingShowMapModal
